import React from 'react'
import { connect } from 'react-redux'
import { getBaseSiteIdFromStudy } from 'utils/misc'
import ClinroIframe from '../components/ClinroIframe'

const mapStateToProps = state => {
  const { user, study } = state
  const { token, access_token } = user
  const userToken = token || access_token
  const studyId = study?.currentStudy?.id
  const siteId = getBaseSiteIdFromStudy(study)

  return {
    userToken,
    studyId,
    siteId,
  }
}

export default connect(mapStateToProps)(ClinroIframe)

